import { history } from '../routers/AppRouter';
import axios from 'axios';
import paths from '../helpers/paths';
import { getToken } from '../helpers/auth';
import { setShoppingCartDetails, getShoppingCartDetails, deleteShoppingCartDetails, 
         setCartMessageResponse, getCartMessageResponse, deleteCartDetails } from '../helpers/cart';
import { setHoverState, } from '../actions/css';
import { setWaitingState, setModalState } from '../actions/css';


// const fetchShoppingCart = `http://localhost:3000/api/v1/cart`;

const fetchShoppingCart = `https://coozallbackend.herokuapp.com/api/v1/cart`;

export const setProductCart = (cart) => (
  {
    type:'SET_CART_DETAILS',
    cart,
  }
);

export const setFetchCart = (fetchCart) => (
  {
    type:'SET_FETCH_CART',
    fetchCart,
  }
);


export const setCartCallBackMessage = (cartResponseMessage) => (
  {
    type: 'SET_CART_MESSAGE',
    cartResponseMessage,
  }
);

export const setCartTotalQuantity = (totalQuantity) => (
  {
    type: 'SET_TOTAL_QUANTITY',
    totalQuantity,
  }
);


export const fetchProductCart = (bag) => dispatch => {
  dispatch(setWaitingState(true));
  dispatch(setCartCallBackMessage(`Please wait.. Retrieving Cart Info.`));
  return axios.get(`${fetchShoppingCart}?cartInfo=${bag}`)
    .then((response) => {
      dispatch(setCartCallBackMessage(response.data.message));
      dispatch(setFetchCart(response.data.data));

      setShoppingCartDetails(response.data.data)
      setCartMessageResponse(response.data.message);
      history.push(paths.shoppingcart);
      dispatch(setHoverState(false));
      dispatch(setWaitingState(false));
      dispatch(setModalState(false));
    })
    .catch((error) => {
      dispatch(setWaitingState(false));
      dispatch(setCartCallBackMessage(error.response.data.error));
      setCartMessageResponse(error.response.data.error); 
      dispatch(setModalState(false));
      dispatch(setHoverState(false));
      dispatch(setFetchCart([]));  
      history.push(paths.shoppingcart);
    });
 };

